import React, { useEffect, useState, useRef, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import "./AssemblyInstructionsPopup.css";
import { useDispatch, useSelector } from "react-redux";
import {
  AddInstructionsAsset,
} from "../../../redux/actions/action";
import {
  Switch,
} from "antd";

const AssemblyInstructionsTwoPopup = (props) => {
  const dispatch = useDispatch();
  const assetId = window.localStorage.getItem("assetId");
  const [instructionsFields, setInstructionsFields] = useState({
    materialName: "material Name",
    title: "",
    instructions: "",
  });

  const handleInputChange = (field, value) => {
    const newInputs = { ...instructionsFields, [field]: value };
    setInstructionsFields(newInputs);
  };


  const handleSubmit = () => {
    const payload = {
      assetId,
      assemblyInstructions: [instructionsFields],
    };

    dispatch(AddInstructionsAsset(payload));
    props.onHide()
    props.isFetchList()
  };

  return (
    <>
      <Modal
        {...props}
        id="assembly_instructions_Popup_two"
        dialogClassName="custum_projectPop"
        // size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Body>

          <div className="assembly_instructions_page_title">
            <h3>Assembly instructions for </h3>
          </div>
          <div className="assembly_instructions_header">
            <div className="assembly_header_add">
              <div style={{ width: "100%" }}>
                <div className="inputBoxContent">
                  <div className="labelBox">
                    <label className="labelText">
                      {/* Title */}
                      Title
                    </label>
                  </div>
                  <input
                    className="contacttabinput"
                    value={instructionsFields.title}
                    name="title"
                    onChange={(e) => { handleInputChange("title", e.target.value); }}
                    type="text"
                    placeholder={"Add the title"}
                  />
                </div>
              </div>
            </div>
            <div className="assembly_instructions_switch">
              Make documentation  <Switch />
            </div>
          </div>

          <div className="documentation-textarea mt-2">
            <div className="inputBoxContent">
              <div className="labelBox">
                <label className="labelText">
                  {/* Instructions */}
                  Instructions
                </label>
              </div>
              <textarea
                className="contacttabinput"
                value={instructionsFields.instructions}
                name="instructions"
                onChange={(e) => {
                  handleInputChange("instructions", e.target.value);
                }}
                type="text"
                placeholder={"Add Instructions"}
              />
            </div>
          </div>



        </Modal.Body>
        <Modal.Footer className="mt-3 justify-content-end px-5">
          <button className="asc_purch_no" onClick={props.onHide}>
            Cancel
          </button>

          {/* <Button onClick={props.handleDelete}>yes</Button> */}
          <button className="asc_purch_yes" onClick={handleSubmit}>
            Add
            {props.loading === true && (
              <div
                className="spinner-border spinner-border-sm ms-2"
                role="status"></div>
            )}
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default AssemblyInstructionsTwoPopup;
